const DEV_TOOLS_DEV = 'prod'; // cambia a prod para restringir la consola en produccion

export default DEV_TOOLS_DEV;